export const getHash = (string: string) => {
    let hash = 0;

    for (let index = 0; index < string.length; index += 1) {
        const char = string.charCodeAt(index);

        hash = (hash << 5) - hash + char;
        hash = hash & hash;
    }

    return String(Math.abs(hash));
};
